(function ($) {
	'use strict';
	// This file is currently not loaded. The parent js file should be sufficient for now.
	console.log('jquery loaded', $.fn);
	console.log('Child theme loaded');

	if (typeof $.fn.slick !== 'undefined') {
		console.log('Slick loaded', $.fn.slick);

		$('.step-slider').slick(
			'slickSetOption',
			'appendArrows',
			$('.step-slider-parent'),
			true
		);

		setTimeout(() => {
			// $('.testimonial-slider').slick(
			// 	'slickSetOption',
			// 	'adaptiveHeight',
			// 	true,
			// 	true
			// );
			$('.step-slider').slick('slickSetOption', 'adaptiveHeight', true, true);
			$('.step-slider').slick('slickSetOption', 'fade', true, false);
		}, 500);

		// $('.testimonial-slider').on('reInit ', () => {
		// 	// $('.testimonial-slider').slick('slickSetOption', 'arrows', true, true);
		// 	console.log('slick init breakpoint setPosition');
		// 	console.log(
		// 		'before: ',
		// 		$('.testimonial-slider').slick('slickGetOption', 'arrows')
		// 	);

		// 	let isMobile = window.matchMedia(
		// 		'only screen and (max-width: 767px)'
		// 	).matches;
		// 	console.log('Is mobile:', isMobile);
		// 	$('.testimonial-slider').slick(
		// 		'slickSetOption',
		// 		'arrows',
		// 		isMobile ? false : true,
		// 		false
		// 	);
		// 	console.log(
		// 		'after: ',
		// 		$('.testimonial-slider').slick('slickGetOption', 'arrows')
		// 	);
		// });
	}
})(jQuery);
